import Aform from '@/components/Aform';
import './index.css';

export default {
  name: 'Amodal',
  components: {
    Aform,
  },
  props: {
    rule: { type: Boolean, default: () => true },
    rules: { type: Object, default: () => ({}) },
    action: { type: Boolean, default: () => true },
    config: { type: Object, default: () => ({}) },
    values: { type: Object, default: () => ({}) },
    finishText: { type: String, default: () => '' },
    submitText: { type: String, default: () => '确定' },
    cancelText: { type: String, default: () => '取消' },
    labelPosition: { type: String, default: () => 'top' },
  },
  render() {
    const { rule, rules, config, values, finishText, submitText, cancelText, labelPosition } = this.$props;
    const { title = '编辑', width = '600px', visible = false, loading = false, ...attrs } = this.$attrs;
    const { finish, submit, cancel } = this.$listeners;
    return (
      <div class={['a-modal', (this.loading ? 'loading' : null)]}>
        <el-dialog visible={visible} title={title} width={width} lock-scroll destroy-on-close close-on-click-modal={false} on-close={cancel} {...{ attrs }}>
          <div class="a-modal-body">
            <Aform
              cols="1"
              size="mini"
              rule={rule}
              rules={rules}
              config={config}
              values={values}
              loading={loading}
              on-finish={finish}
              on-submit={submit}
              on-cancel={cancel}
              finishText={finishText}
              submitText={submitText}
              cancelText={cancelText}
              labelPosition={labelPosition}
            />
          </div>
          {this.$slots.default}
          <div class={this.action ? 'a-modal-foot custom' : ''} />
        </el-dialog>
      </div>
    );
  }
}